// Copyright (c) 2015, Sony Global Education, Inc.
// All rights reserved.

import $ from "jquery";
import "./slick.js";

////////////////////////////////////////////////////////////
//
// Initializer

export function fthinking_main() {
  $("#type_detail").slick({
    infinite: false,
    arrows: false,
    dots: true,
    centerMode: true,
    variableWidth: true,
  });
}

// EOF
